import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { ListItemButtonProps, ListItemIcon, ListItemText } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupPageOptionProps as Props } from './types';

export const AdvancedTableSelectPopupPageOption = memo(
  ({ className, handleClick, size }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('AdvancedTableSelectPopupPageOption', className)}
        sx={SX.root}
        onClick={handleClick as ListItemButtonProps['onClick']}
      >
        <ListItemIcon>
          <Icon name="outline-source" color="grey.800" size={18} />
        </ListItemIcon>

        <ListItemText sx={SX.text}>Select This Page ({size})</ListItemText>
      </Styled.Wrapper>
    );
  }
);

AdvancedTableSelectPopupPageOption.displayName =
  'AdvancedTableSelectPopupPageOption';
